import { UI_CONFIG } from '@porterin/booking-flow/src/auth/domain/config/ui';
import React from 'react';
import ReactModal from 'react-modal';

import styles from '../styles/PnmModal.module.scss';

import PaymentFailureCmp from './Payment-failure/components/PaymentFailureCmp';
import PaymentSuccessCmp from './payment-success/components/PaymentSuccessCmp';

export type PaymentStatus = number | { TAG: number; _0: string };

interface PaymentStatusModalCmpProps {
  modal_state: boolean;
  close_modal: () => void;
  payment_status: PaymentStatus;
  booking_flow: number;
}

function PaymentStatusModalCmp({
  modal_state,
  close_modal,
  payment_status,
  booking_flow,
}: Readonly<PaymentStatusModalCmpProps>): React.ReactElement {
  let content: React.ReactElement | null;
  if (typeof payment_status === 'object') {
    content = (
      <PaymentFailureCmp
        payment_amount={payment_status._0}
        close_modal={close_modal}
      />
    );
  } else {
    content = booking_flow ? null : <PaymentSuccessCmp />;
  }

  return (
    <ReactModal
      isOpen={modal_state}
      onRequestClose={close_modal}
      closeTimeoutMS={UI_CONFIG.MODAL_CLOSE_TIMEOUT}
      overlayClassName={styles['overlay']}
      className={styles['modal-container']}
      ariaHideApp={false}
      shouldCloseOnOverlayClick
    >
      {content}
    </ReactModal>
  );
}

export default PaymentStatusModalCmp;
